<script lang="ts">
	import { ParameterCardGroupV2, ParameterCardV2 } from '@Shelly/shelly-design-system/index';
	import { capFirstChar } from 'src/helpers/utilities';
	import { format } from 'svelte-i18n';
	import { mapIconToThin } from 'src/helpers/new-layout-helpers';

	export let pillMode, mainLabel, statuses;

	const getTempHumidityCard = () => {
		return (
			statuses.reduce((acc, i) => {
				if (i.peripheralType === 'temperature' || i.peripheralType === 'humidity') {
					acc.push({
						icon: mapIconToThin(i.icon),
						iconColor: i?.iconColor,
						title: i?.value,
						description: capFirstChar(
							$format(`title_chart_${i.peripheralType}`, {
								default: i.peripheralType,
							}) || '',
						),
					});
				}
				return acc;
			}, []) || []
		);
	};
</script>

{#if pillMode === 'dht22'}
	<ParameterCardGroupV2 sectionParameters={getTempHumidityCard()} />
{:else if mainLabel}
	<ParameterCardV2
		icon={mapIconToThin(mainLabel?.icon)}
		iconColor={mainLabel?.iconColor || ''}
		title={capFirstChar(mainLabel?.value)}
		description={mainLabel?.sensor?.name || ''}
	/>
{/if}
